import { useI18N } from "@sundae/react-hooks";
import { ArrowLeftIcon, ArrowRightIcon, Button, Dialog, toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import { memo, useEffect } from "react";
import { useIsWalletConnected } from "../../hooks/useIsWalletConnected";
import { useAppContext } from "../../stores";
import { useFirstVisitContext } from "../../stores/FirstVisitContext";
import ConnectWalletButton from "../ConnectWalletButton";

const FirstVisitDialogs = () => {
  const { t } = useI18N();
  const {
    state: { walletConnectOpen },
  } = useAppContext();
  const isWalletConnected = useIsWalletConnected();
  const { components, currentComponentIndex, handleOnSpecificIndex } = useFirstVisitContext();
  const CurrentComponent = components[currentComponentIndex];
  const handleCloseDialogs = () => handleOnSpecificIndex(components.length);

  const renderButtons = () => {
    const iconCx = "h-4 w-4";

    if (components.length === 1) {
      return (
        <Button variant="primary" onClick={() => handleOnSpecificIndex(components.length)}>
          {t("close")}
        </Button>
      );
    }

    if (!currentComponentIndex && components.length > 1) {
      return (
        <Button variant="primary" onClick={() => handleOnSpecificIndex(currentComponentIndex + 1)}>
          {t("continue")}
          <ArrowRightIcon className={iconCx} />
        </Button>
      );
    }

    if (currentComponentIndex === components.length - 1 && components.length > 1) {
      return (
        <>
          <Button
            variant="secondary"
            onClick={() => handleOnSpecificIndex(currentComponentIndex - 1)}
          >
            <ArrowLeftIcon className={iconCx} />
            {t("back")}
          </Button>
          <ConnectWalletButton size="lg" />
        </>
      );
    }

    if (currentComponentIndex && components.length > 1) {
      return (
        <>
          <Button
            variant="secondary"
            onClick={() => handleOnSpecificIndex(currentComponentIndex - 1)}
          >
            <ArrowLeftIcon className={iconCx} />
            {t("back")}
          </Button>
          <Button
            variant="primary"
            onClick={() => handleOnSpecificIndex(currentComponentIndex + 1)}
          >
            {t("continue")}
            <ArrowRightIcon />
          </Button>
        </>
      );
    }

    return null;
  };

  useEffect(() => {
    if (isWalletConnected || walletConnectOpen) {
      handleCloseDialogs();
    }
  }, [isWalletConnected, walletConnectOpen]);

  return (
    <Dialog closeDialog={handleCloseDialogs} open>
      <div className="grid gap-8">
        <div className="grid gap-6">
          <div className={cx(toolkitCx.layout.spacing.top.md)}>
            <CurrentComponent />
          </div>

          {components.length > 1 && (
            <div className="flex w-full items-center justify-center gap-2">
              {components.map((_, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => handleOnSpecificIndex(index)}
                    className={cx(
                      "h-2 w-2 cursor-pointer rounded-full hover:bg-primary/20 dark:hover:bg-primary/40",
                      {
                        [`!${toolkitCx.layout.background.primary}`]:
                          index === currentComponentIndex,
                        "bg-gray-200 dark:bg-gray-600": index !== currentComponentIndex,
                      },
                      toolkitCx.layout.transition.colors
                    )}
                  />
                );
              })}
            </div>
          )}
        </div>

        <div className="flex w-full items-center justify-center gap-4">{renderButtons()}</div>
      </div>
    </Dialog>
  );
};

export default memo(FirstVisitDialogs);
